import { TMessage } from '../types/messages';
import { TOpenedChat } from '../types/openedChats';

type TFindLastIncomingMessageParams = {
  chat: TOpenedChat;
  messageIndex: number;
  incoming?: boolean;
};

export function findLastMessage({
  chat,
  messageIndex,
  incoming = true,
}: TFindLastIncomingMessageParams): TMessage | null {
  const { message } = chat.chatMessages[messageIndex] || {};
  if (message && (!message.isOutcoming || !incoming)) {
    return message;
  }

  if (messageIndex > 0) {
    return findLastMessage({ chat, messageIndex: messageIndex - 1 });
  }

  return null;
}
